import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../../widgets/tables/Table';
import { NineCellLoading } from 'react-loadingg';
import getSupportTickets from "../../services/getSupportTickets";
import translateString from '../../utils/Locales';
import getClient from "../../services/getClient";

let t = translateString;

export default class SendFeedback extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
      newTicket: false,
      isLoading: true,
    };

  }
  
  async load() {

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.cliente = await getClient('', '', cookies.get('db', { path: '/' }));
    this.tickets = await getSupportTickets(username, token);
    console.log(this.tickets);
    this.tickets.forEach((ticket) => {
      if (ticket.solved == 0) {
        ticket.solved = t('in_lavorazione');
      } else {
        ticket.solved = t('conclusa');
      }
    });
    this.tickets = this.tickets.filter((ticket) => ticket.id_thread === null);

    this.setState({ isLoading: false });
  }

  async componentDidMount(){
      await this.load();
  }

  render () {

    var headCells = [
      { id: 'creation_date', numeric: true, disablePadding: false, label: t('data') },
      { id: 'subject', numeric: false, disablePadding: true, label: t('oggetto') },
      { id: 'solved', numeric: true, disablePadding: false, label: t('stato') },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    this.searchCols = ['subject', 'message'];

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <div>
          <PageTitle title={t('assistenza')} button={t('nuovo_tick')} secondButton={this.cliente.type !== '0' ? t('fissa_una_call').toUpperCase() : false} onClick={() => {
              window.location.href = '/' + new Cookies().get('db', { path: '/' }) + '/#/app/ticketDetails';
          }}
          onSecondClick={() => window.open('https://calendly.com/appius/30min?name=Assistenza: ' + this.cliente.ragioneSociale + '&email=' + this.cliente.mail, '_blank')} />

          <Table headCells={headCells} searchCols={this.searchCols} calendar={false} pdf={false} excel={false} mail={false} phone={false} rows={this.tickets}
      
              onEventClick={(row) => {
                  const cookies = new Cookies();
                  const dbPath = cookies.get('db', { path: '/' });
                  window.location.href = '/' + dbPath + '/#/app/ticketDetails?ticket=' + row;
              }}
          />
      </div>
    );
  }
}

